import { getConfig } from 'EnvConfig'

import { getEcpDomain } from './ecp-domain'
import { getPublicConfigRequestHeaders } from './request-headers'

export type BootstrapPortalConfig = {
  prevent_search_engine_indexing?: boolean
  is_dummy?: boolean
  [key: string]: unknown
}

export const fetchPublicPortalConfig =
  async (): Promise<BootstrapPortalConfig> => {
    const domain = getEcpDomain()
    const { CUSTOMER_PORTAL_API_URL } = getConfig()
    const url = new URL(`${CUSTOMER_PORTAL_API_URL}/v2/portal/public/config`)

    url.searchParams.set('domain', domain)

    const response = await fetch(url.toString(), {
      method: 'GET',
      headers: getPublicConfigRequestHeaders()
    })

    if (!response.ok) {
      throw new Error(
        `Failed to fetch public portal config (${response.status})`
      )
    }

    return (await response.json()) as BootstrapPortalConfig
  }
